import React from "react";
import CollectionTitleCell from "collections/components/common/cells/CollectionTitleCell";
const customColumnRenderers = {
  attributes: {
    title: {
      renderCell: (title, collection) => /* @__PURE__ */ React.createElement(CollectionTitleCell, { title, id: collection.id })
    }
  }
};
export default customColumnRenderers;
